<template lang="pug"></template>

<script>
export default {
    name: 'BotaoGestaoLotesPssc',
    componentOptions: {
        title: 'Lotes',
        actions: [
            [
                {
                    name: 'Lotes',
                    iconClass: 'lyra-icon lyra-gestao',
                    showView: false,
                    action: 'abrir',
                    route: 'GestaoLotesPssc'
                }
            ]
        ]
    },

    methods: {
        abrir() {
            if (this.$route.name !== 'GestaoLotesPssc') {
                this.$router.push({ name: 'GestaoLotesPssc' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
